import { OhVueIcon, addIcons } from 'oh-vue-icons'
import {
	BiArrowClockwise,
	BiArrowDown,
	BiArrowLeft,
	BiBoxArrowUpRight,
	BiCalendar,
	BiCash,
	BiCashStack,
	BiCheck,
	BiCheckCircle,
	BiCheckCircleFill,
	BiChevronRight,
	BiClipboardFill,
	BiClockHistory,
	BiFileText,
	BiHouseDoor,
	BiHouseHeart,
	BiInfoCircle,
	BiLightbulb,
	BiLink45Deg,
	BiListCheck,
	BiPalette,
	RiPencilFill,
	BiPlus,
	BiShareFill,
	BiSliders,
	BiThermometerHalf,
	BiTrash,
	BiX,
	BiXCircle,
	BiArrowRight,
	BiExclamationTriangle,
	MdGpsfixed,
} from 'oh-vue-icons/icons'

addIcons(
	BiArrowClockwise,
	BiArrowDown,
	BiArrowLeft,
	BiBoxArrowUpRight,
	BiCalendar,
	BiCash,
	BiCashStack,
	BiCheck,
	BiCheckCircle,
	BiCheckCircleFill,
	BiChevronRight,
	BiClipboardFill,
	BiClockHistory,
	BiFileText,
	BiHouseDoor,
	BiHouseHeart,
	BiInfoCircle,
	BiLightbulb,
	BiLink45Deg,
	BiListCheck,
	BiPalette,
	BiPlus,
	BiShareFill,
	BiSliders,
	BiThermometerHalf,
	BiTrash,
	BiX,
	BiXCircle,
	BiArrowRight,
	BiExclamationTriangle,
	MdGpsfixed,
	RiPencilFill,
)

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.component('v-icon', OhVueIcon)
})
